import React from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import { currencyDisplay } from '../../_utils';

function ProductVariationListItemPrice(props) {
    const { item, cartQty, currencyFormat, currencyDisplayCode, locale } = props;
    const { ProdType, SalePrice, RRP, IsSale } = item;

    if (typeof SalePrice == 'undefined' || SalePrice == null) {
        return '';
    }

    return (
        <React.Fragment>
            {ProdType == 'ID' && (
                <span className='products-data-table__price products-data-table__price--from'>
                    <LocalizedMessage id={'FROM'} />
                </span>
            )}
            <span className='products-data-table__price'>
                {currencyDisplay(SalePrice * cartQty, currencyDisplayCode, currencyFormat, locale)}
            </span>
            {ProdType == 'RP' && IsSale && RRP != null && (
                <span className='products-data-table__price products-data-table__price--crossed'>
                    {currencyDisplay(RRP * cartQty, currencyDisplayCode, currencyFormat, locale)}
                </span>
            )}            
        </React.Fragment>
    );
}

// default props
ProductVariationListItemPrice.defaultProps = {
    item: {},
};
// validate props
ProductVariationListItemPrice.propTypes = {
    item: PropTypes.any.isRequired,
};

export default ProductVariationListItemPrice;
